export default function TripCheckoutModalController(
    $scope,
    $uibModalInstance,
    $state,
    $stateParams,
    flightsUtils,
    modalData
) {
    'ngInject';

            $scope.lastFlight = flightsUtils.lastFlight;
            $scope.collectAllCities = flightsUtils.collectAllCities;

            $scope.modal = modalData;

            $scope.collectAllCities = function(flightGroups) {
                return flightsUtils.collectAllCities(flightGroups).join(' - ');
            };

            /**
             * Close modal and proceed
             */
            $scope.ok = function() {
                if ($scope.modal.reload) {
                    closeModalAndReload();
                } else {
                    $uibModalInstance.close($scope.modal.redirectTo);
                }
            };

            /**
             * Close modal and dismiss
             */
            $scope.cancel = function() {
                $uibModalInstance.dismiss('cancel');
            };

            function closeModalAndReload() {
                $uibModalInstance.close();
                $state.transitionTo($state.current, $stateParams, {
                    reload: true,
                    inherit: false,
                    notify: true,
                });
            }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/controllers/checkout/tripCheckoutModalCtrl.js